/*
 * Module for the status pills used by the reviewer tasks list
 */

define([
  "marionette",
  "messaging/messenger",
  "./reviewerTasksListToggleView",
  "modules/tasks/tasksModel",
], function (Marionette, Messenger, ReviewerTasksListToggleView, TaskModel) {
  "use strict";

  var ReviewerTasksListToggleController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "reviewerTasksListToggle";
      this.region = options.region;
    },
    show: function () {
      this.view = new ReviewerTasksListToggleView.reviewerTasksListToggleView();

      this.view.on(
        "show:not:started",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              Messenger.vent.trigger("show:tasks:list", TaskModel.STATUS.NOT_STARTED);
            }
          }, this);
        },
        this,
      );

      this.view.on(
        "show:in:progress",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              Messenger.vent.trigger("show:tasks:list", TaskModel.STATUS.IN_PROGRESS);
            }
          }, this);
        },
        this,
      );

      this.view.on(
        "show:rejected",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              Messenger.vent.trigger("show:tasks:list", TaskModel.STATUS.FAILED);
            }
          }, this);
        },
        this,
      );

      this.showRegion(this.view);
    },
    selectTab: function (statusId) {
      if (statusId === TaskModel.STATUS.NOT_STARTED) {
        this.view.selectNotStarted();
      }
    },
  });

  return ReviewerTasksListToggleController;
});
